export default "__VITE_ASSET__D7$y2LLO__"